module.exports = __webpack_public_path__ + "static/media/fly0265.6117b1cc.webp";